export default {
  "Bureau": "_Bureau_2qt8i_1",
  "TableHeader": "_TableHeader_2qt8i_5",
  "Table": "_Table_2qt8i_5",
  "Welcome": "_Welcome_2qt8i_18",
  "Drawer": "_Drawer_2qt8i_27",
  "RowSpacer": "_RowSpacer_2qt8i_32"
};import "ni:sha-256;ddZWmejLBWw8evvmXlTSIMz1WZX_psHL7pVLJAoqpfs";